import { createFileRoute, lazyRouteComponent, notFound } from "@tanstack/react-router";
import { ENABLE_HUMAN_REVIEW } from "shared/SharedConstants";

// Beta. While ENABLE_HUMAN_REVIEW is false the inline-constants transform folds the branches, so the
// page answers 404 and its component never reaches the build.
export const Route = createFileRoute("/_authed/portal/proj_{$projectKey}/human-review")({
  // The page is already a lazy chunk; a second split by TanStack would load it after hydration
  // (see design-system.tsx).
  codeSplitGroupings: [],
  beforeLoad: () => {
    if (!ENABLE_HUMAN_REVIEW) throw notFound();
  },
  component: ENABLE_HUMAN_REVIEW
    ? lazyRouteComponent(() => import("src/components/app/HumanReview/HumanReviewPage"))
    : () => null,
});
